// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cms-editor {
    border: 1px solid rgba(0, 0, 0, 0.8);
    border-radius: 3px;
    overflow: hidden;
}

.cms-editor__toolbar {
    gap: 8px;
    width: 100%;
    height: 42px;
    padding-left: 10px;
    border-bottom: 1px solid grey;
    display: flex;
    align-items: center;
    justify-content: start;
    padding-right: 10px;
    background: rgba(255, 255, 255, 1);
}

.cms-editor__toolbar button {
    cursor: pointer;
    background-color: transparent;
    border-radius: 5px;
    border: none;
    transition: all 0.3s;
    color: rgba(138, 139, 143, 1);
}

.cms-editor__toolbar .list-btn-style-cmd {
    width: 28px;
    height: 28px;
    position: relative;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
}

.cms-editor__toolbar .bold-style-cmd {
    width: 28px;
    height: 28px;
    border: 1px solid transparent;
}

.cms-editor__toolbar  .list-btn-style-cmd svg path{
    transition: all 0.3s;
}

.cms-editor__toolbar button:hover, .cms-editor__toolbar  .list-btn-style-cmd:hover svg path{
    background-color: rgba(239, 243, 248, 1);
    color: black;
    fill: black;
}

.cms-editor__toolbar button.is-active, .cms-editor__toolbar  .list-btn-style-cmd.is-active svg path {
    font-weight: bold;
    background: rgba(35, 136, 255, 1);
    color: white;
    fill: white;
}

/* ProseMirror root */
.cms-editor .ProseMirror {
    min-height: var(--minH);
    padding: 12px;
    outline: none;
    box-sizing: border-box;
    color: black;
    font-family: var(--font-family-inter);
    font-size: 16px;
}

.cms-editor .ProseMirror p{
    padding: 0;
    margin: 0;
}

/* Make sure lists actually display bullets/numbers */
.cms-editor .ProseMirror ul {
    list-style: disc;
    padding-left: 10px;
    margin: 0px;
}

.cms-editor .ProseMirror ol {
    list-style: decimal;
    padding-left: 24px;
}

.cms-editor .ProseMirror li::marker {
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/texteditor-fs-cp/tip-tap-editor/css/cms-editor.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,YAAY;IACZ,WAAW;AACf;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA,qDAAqD;AACrD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".cms-editor {\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.cms-editor__toolbar {\n    gap: 8px;\n    width: 100%;\n    height: 42px;\n    padding-left: 10px;\n    border-bottom: 1px solid grey;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding-right: 10px;\n    background: rgba(255, 255, 255, 1);\n}\n\n.cms-editor__toolbar button {\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 5px;\n    border: none;\n    transition: all 0.3s;\n    color: rgba(138, 139, 143, 1);\n}\n\n.cms-editor__toolbar .list-btn-style-cmd {\n    width: 28px;\n    height: 28px;\n    position: relative;\n    border: 1px solid transparent;\n    display: flex;\n    align-items: center;\n}\n\n.cms-editor__toolbar .bold-style-cmd {\n    width: 28px;\n    height: 28px;\n    border: 1px solid transparent;\n}\n\n.cms-editor__toolbar  .list-btn-style-cmd svg path{\n    transition: all 0.3s;\n}\n\n.cms-editor__toolbar button:hover, .cms-editor__toolbar  .list-btn-style-cmd:hover svg path{\n    background-color: rgba(239, 243, 248, 1);\n    color: black;\n    fill: black;\n}\n\n.cms-editor__toolbar button.is-active, .cms-editor__toolbar  .list-btn-style-cmd.is-active svg path {\n    font-weight: bold;\n    background: rgba(35, 136, 255, 1);\n    color: white;\n    fill: white;\n}\n\n/* ProseMirror root */\n.cms-editor .ProseMirror {\n    min-height: var(--minH);\n    padding: 12px;\n    outline: none;\n    box-sizing: border-box;\n    color: black;\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n}\n\n.cms-editor .ProseMirror p{\n    padding: 0;\n    margin: 0;\n}\n\n/* Make sure lists actually display bullets/numbers */\n.cms-editor .ProseMirror ul {\n    list-style: disc;\n    padding-left: 10px;\n    margin: 0px;\n}\n\n.cms-editor .ProseMirror ol {\n    list-style: decimal;\n    padding-left: 24px;\n}\n\n.cms-editor .ProseMirror li::marker {\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
